/**
 * Fragment keys the identity provider returns to the redirect URI
 * (successful and error responses alike).
 */
const AUTH_RESPONSE_HASH_PARAMS: readonly string[] = [
  'state',
  'code',
  'error',
  'error_description',
  'id_token',
  'access_token',
  'client_info',
  'ear_jwe',
];

/**
 * Keys must carry a value so plain anchors such as `#code` or `#error` are not
 * mistaken for an auth response.
 * @param fragment - URL fragment without the leading `#`
 */
export function isAuthResponseHash(fragment: string): boolean {
  const params = new URLSearchParams(fragment);
  return AUTH_RESPONSE_HASH_PARAMS.some(param => Boolean(params.get(param)));
}
